/**
 * The page patients are texted to save the practice's contact card. The backend builds the
 * Customer.io `contactCardUrl` trait from the same path (`PlatformContactCardRoute.SavePagePath`),
 * so the two must change together.
 */
export const SAVE_CONTACT_PATH = "/save-contact";
